import {ModuleRouteManifest} from '../types'

export const curriculumRouteManifest: ModuleRouteManifest = {
  code: 'curriculum',
  privateRoutes: [
    'program-outcome-achievement',
    'courseoutcomesreport',
    'my-course-outcome',
    'organizationoutcomescontribution',
    'courseoutcomequestion/*',
    'learningobjectivequestion/*',
    'course/*',
    'my-course/*',
    'my-course-b/*',
    'my-boardmodule/*',
    'courseoutcome/*',
    'organization/*',
    'organizationeducationpurpose/*',
    'organizationoutcome/*',
    'outcomepoint/*',
    'semester/*',
    'semestercourse/*',
    'studentsemestercourse/*',
    'semestercoursereport/*',
    'courseorganizationoutcomematrix/*',
    'boardmodule/*',
    'boardmoduleobjective/*',
    'boardschedule/*',
    'boardtimeslotset/*',
  ],
}
